import React from 'react';
import * as styles from './style.module.scss';

const { loadingPlaceholder } = styles;

const Spinner = ({ color = 'blue' }) => {
  // const colorClass = {
  //   blue: spinnerBlue,
  //   white: spinnerWhite,
  // };

  // const className = `${spinner} ${colorClass[color] || spinnerBlue}`;

  return (
    // <div className={spinnerContainer}>
    //   <div className={className}></div>
    // </div>
    <div className={loadingPlaceholder} aria-hidden="true" />
  );
};

export default Spinner;
